import classNames from "classnames";
import { useState } from "react";
import { Badge, Button, Container, Form, InputGroup, Modal } from "react-bootstrap";
import styled from "styled-components";

export const SContainer = styled(Container)`
  background-color: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-light)")};

  min-height: ${(props) => (props.fill ? "100vh" : "auto")};
`;

export const SButton = styled(Button)`
  border-radius: 99em;
  border: none;
  padding: 0.5rem;

  background-color: ${(props) => (props.dark ? "var(--primary-light)" : "var(--primary-dark)")};
  color: ${(props) => (props.dark ? "var(--text-primary-light)" : "var(--text-primary-dark)")};

  text-transform: capitalize;

  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 !important;

  :hover,
  :focus {
    border: none;
    background-color: ${(props) => (props.dark ? "var(--primary-light)" : "var(--primary-dark)")};
    color: ${(props) => (props.dark ? "var(--text-primary-light)" : "var(--text-primary-dark)")};
  }

  :hover {
    background-color: ${(props) =>
      props.dark ? "rgba(var(--primary-light-rgb), 0.8)" : "rgba(var(--primary-dark-rgb), 0.8)"} !important;
  }

  transition: none !important;
`;

export const SSecondaryButton = styled(Button)`
  border-radius: 99em;
  border: none;
  padding: 0.5rem;

  background-color: var(--primary-light);
  color: var(--primary-dark);

  text-transform: capitalize;

  display: flex;
  flex-direction: row;
  justify-content: center;

  transition: none !important;
`;

export const SFormCheck = styled(Form.Check)`
  .form-check-input {
    border: none;
    border-radius: 99em;
  }

  .form-check-input:checked {
    background-color: var(--secondary-dark);
    border-color: var(--secondary-dark);
    border-width: 0;
  }

  .form-check-input:focus {
    box-shadow: none;
  }

  input[type="radio"],
  input[type="checkbox"] {
    transform: scale(1.5);
  }

  .form-check-label {
    color: var(--text-primary-dark);
  }
`;

export const SFormControl = styled(Form.Control)`
  border-radius: 99em;
  border: none;
  box-shadow: none;

  padding: 0.5em 1.5em;

  background-color: var(--secondary-dark);
  color: var(--text-primary-dark);

  ::placeholder {
    text-transform: uppercase;
    color: var(--text-secondary-dark);
  }

  :focus {
    box-shadow: none;
    background-color: var(--secondary-dark);
    color: var(--text-primary-dark);
  }

  ::file-selector-button {
    border-radius: 99em;
    transform: translateX(-1rem);
    background-color: var(--primary-light);
    color: var(--text-primary-light);
  }
`;

export const SPasswordShowButton = styled(InputGroup.Text)`
  border-radius: 99em;
  border: none;

  background-color: ${(props) => (props.show ? "var(--primary-dark)" : "var(--secondary-dark)")};
  box-shadow: none;

  color: var(--text-secondary-dark);
  color: ${(props) => (props.show ? "var(--on-accent-primary-dark)" : "var(--text-secondary-dark)")};

  transition-duration: 200ms;
`;

export const SParagraph = styled.p`
  color: var(--text-primary-dark);

  a {
    color: var(--text-primary-dark);
  }
`;

export const STitle = styled.h2`
  color: var(--text-primary-dark);
`;

export const SBadge = styled(Badge)`
  background-color: ${(props) => (props.dark ? "var(--primary-dark)" : "var(--primary-light)")} !important;
  color: ${(props) => (props.dark ? "var(--text-primary-light)" : "var(--text-primary-dark)")} !important;
`;

export const PasswordField = (props) => {
  const [hidePwd, setHidePwd] = useState(true);

  return (
    <InputGroup className="my-3">
      <SFormControl
        {...props}
        type={hidePwd ? "password" : "text"}
        placeholder="password"
        className="fs-5"
        aria-describedby="basic-addon2"
      />
      <SPasswordShowButton
        variant="outline-secondary"
        id="button-addon2"
        className="fs-5"
        $show={!hidePwd}
        onClick={() => setHidePwd(!hidePwd)}
      >
        <i
          className={classNames("fas", {
            "fa-eye": !hidePwd,
            "fa-eye-slash": hidePwd,
          })}
        />
      </SPasswordShowButton>
    </InputGroup>
  );
};

export const SError = styled.div`
  border-radius: 99em;
  border: none;
  box-shadow: none;

  padding: 0.5em 1.5em;
  background-color: var(--primary-light);
  color: red;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
`;

export const SModal = styled(Modal)``;
